import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import service from "../baseHttpService";

class SummaryService {
  DoGetRevenueExpenseSummary(year: number) {
    const _input = {
      merchantId: MerchantId(),
      year: year,
    };
    return service.peakExportAPI
      .post("/api/DashBoard/GetRevenueAndExpenseSummary", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
  DoSummaryInvoiceRemainPayment(financeTypeId: number) {
    const _input = {
      merchantId: MerchantId(),
      date: new Date(),
      financeTypeId: financeTypeId,
    };
    return service.peakExportAPI
      .post("/api/DashBoard/GetSummaryInvoiceRemainPayment", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
  DoGetRevenueProductSummary(typeSelectOption: any) {
    const _input = {
      merchantId: MerchantId(),
      language: i18n.locale,
      date: new Date(),
      dashboardSelectOptionTypeId: typeSelectOption,
    };
    return service.peakExportAPI
      .post("/api/DashBoard/GetRevenueProductSummary", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
  DoGetExpenseProductSummary(typeSelectOption: number) {
    const _input = {
      merchantId: MerchantId(),
      language: i18n.locale,
      date: new Date(),
      dashboardSelectOptionTypeId: typeSelectOption,
    };
    return service.peakExportAPI
      .post("/api/DashBoard/GetExpenseProductSummary", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
  DoGetRevenueContactSummary(typeSelectOption: number) {
    const _input = {
      merchantId: MerchantId(),
      language: i18n.locale,
      date: new Date(),
      dashboardSelectOptionTypeId: typeSelectOption,
    };

    return service.peakExportAPI
      .post("/api/DashBoard/GetRevenueContactSummary", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
  DoGetExpenseContactSummary(typeSelectOption: number) {
    const _input = {
      merchantId: MerchantId(),
      language: i18n.locale,
      date: new Date(),
      dashboardSelectOptionTypeId: typeSelectOption,
    };

    return service.peakExportAPI
      .post("/api/DashBoard/GetExpenseContactSummary", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
  DoGetRevenueAccountSummary(typeSelectOption: number) {
    const _input = {
      merchantId: MerchantId(),
      language: i18n.locale,
      date: new Date(),
      dashboardSelectOptionTypeId: typeSelectOption,
    };

    return service.peakExportAPI
      .post("/api/DashBoard/GetRevenueAccountSummary", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
  DoGetExpenseAccountSummary(typeSelectOption: number) {
    const _input = {
      merchantId: MerchantId(),
      language: i18n.locale,
      date: new Date(),
      dashboardSelectOptionTypeId: typeSelectOption,
    };

    return service.peakExportAPI
      .post("/api/DashBoard/GetExpenseAccountSummary", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
  DoGetFinanceSummary(typeSelectOption: number) {
    const _input = {
      merchantId: MerchantId(),
      language: i18n.locale,
      date: new Date(),
      dashboardSelectOptionTypeId: typeSelectOption,
    };
    return service.peakExportAPI
      .post("/api/DashBoard/GetFinanceSummary", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
  DoGetRemainPaymentSummaryByPeriodType(_payload: any) {
    const _input = {
      merchantId: MerchantId(),
      financeTypeId: _payload.financeTypeId,
      invoiceRemainPaymentSummaryPeriodTypeId: _payload.invoiceRemainPaymentSummaryPeriodTypeId,
      fromDate: _payload.fromDate,
      toDate: _payload.toDate,
    };

    return service.peakExportAPI
      .post("/api/DashBoard/GetRemainPaymentSummaryByPeriodType", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
  DoGetContactDashboardSummary(input: any) {
    const _input = {
      merchantId: MerchantId(),
      date: new Date(),
      dashboardSelectOptionTypeId: input.selectMonth,
      contactId: input.contactId,
      financeTypeId: input.financeTypeId,
      language: i18n.locale,
    };
    return service.peakExportAPI
      .post("/api/DashBoard/GetContactDashboardSummary", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      
  }
}

export default new SummaryService();
